export default __webpack_public_path__ + "locales/sl/RoomLogoCover.json?hash=1f4c36175a229a5ed72de62febd8906b";